export * from './breakpoints';
export * from './zindexes';
export var CPO_KEY = 'certified_pre-owned';
export var ALL_PHONES_KEY = 'all_categories';
export var ALL_TABLETS_KEY = 'all_categories_tablets';
export var PHONE = 'PHONE';
export var DEVICE_TYPE = {
    PHONE: 'PHONE',
    TABLET: 'TABLET'
};
export * from './colors';
